import { post } from '../Services/http';
import { catchError } from './Error.action';
import {
    QUICK_SEARCH_QUERY,
    QUICK_SEARCH_RECEIVE,
    QUICK_SEARCH_ERROR,
    QUICK_SEARCH_SHOW_FULL_FORM,
    QUICK_SEARCH_SELECT_ITEM,
    QUICK_BIG_SEARCH_QUERY,
    QUICK_BIG_SEARCH_RECEIVE,
    QUICK_BIG_SEARCH_ERROR,
    QUICK_BIG_SEARCH_SHOW_FULL_FORM,
    QUICK_BIG_SEARCH_SELECT_ITEM,    
} from '../constants';

import {
  setArticleNumberToFetchPrices,
  getPrices
} from './CustomerPrices.action';

let abortController;

export const fetchPrices = (result) => (dispatch) => {
    //If any of the product results only have basePrice, we need to initiate a fetch of customer prices
    //console.log("fetchPrices quick search", { result });
  var productsNeedingPrices = result
    .filter((i) => i.isProduct && i.isBasePrice)
    .map((m) => m.id);

  if (productsNeedingPrices.length > 0) {
    productsNeedingPrices.map((x) => {
      dispatch(setArticleNumberToFetchPrices(x));
    });
    // Immediately trigger the price fetch (quick search used to only queue ids,
    // and relied on a CustomerPrices instance to trigger getPrices via its
    // fetchPrices prop � but quick search result array includes non-product
    // entries so that trigger can be missed and the loader remains).
    dispatch(getPrices(false));
  }
};

export const query = (q, isBigSearch) => (dispatch) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    return post('/api/quickSearch', q, abortController)
        .then((response) => response.json())
        .then((result) => {
            dispatch(fetchPrices(result));
            if (isBigSearch) {
                dispatch(receiveBig(result))
            }
            else{
                dispatch(receive(result))
            }
        })
        .catch((ex) => {
            if (isBigSearch){
                dispatch(catchError(ex, (error) => searchBigError(error)))
            }
            else{
                dispatch(catchError(ex, (error) => searchError(error)))
            }
        });
};

export const setSearchQuery = (query) => ({
    type: QUICK_SEARCH_QUERY,
    payload: {
        query,
    },
});

export const setBigSearchQuery = (query) => ({
    type: QUICK_BIG_SEARCH_QUERY,
    payload: {
        query,
    },
});


export const searchError = (error) => ({
    type: QUICK_SEARCH_ERROR,
    payload: {
        error,
    },
});

export const searchBigError = (error) => ({
    type: QUICK_BIG_SEARCH_ERROR,
    payload: {
        error,
    },
});

export const receiveBig = (result) => ({
    type: QUICK_BIG_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result && result.length > 0,
    },
});

export const receive = (result) => ({
    type: QUICK_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result && result.length > 0,
    },
});

export const toggleShowFullForm = (isBigSearch) => (dispatch, getState) => {
    if (isBigSearch){
        dispatch(showBig(!getState().quickBigSearch.showFullForm));
    }
    else{
        dispatch(show(!getState().quickSearch.showFullForm));
    }
    
};

const show = (visible) => ({
    type: QUICK_SEARCH_SHOW_FULL_FORM,
    payload: {
        showFullForm: visible,
    },
});

const showBig = (visible) => ({
    type: QUICK_BIG_SEARCH_SHOW_FULL_FORM,
    payload: {
        showFullForm: visible,
    },
});

export const handleKeyDown = (event, opt, isBigSearch) => (dispatch, getState) => {
    const { result, selectedItem } = isBigSearch ? getState().quickBigSearch : getState().quickSearch;

    if (!result || !result.length) {
        return;
    }
    const max = result.length - 1,
        clip = (index) => (index < 0 ? max : index > max ? 0 : index);
    switch (event.keyCode) {
        case 38:
            if (isBigSearch){
                dispatch(selectBigItem(clip(selectedItem - 1)));
            }
            else{
                dispatch(selectItem(clip(selectedItem - 1)));
            }
            
            break;
        case 40:
            if (isBigSearch){
                dispatch(selectBigItem(clip(selectedItem + 1)));
            }
            else{
                dispatch(selectItem(clip(selectedItem + 1)));
            }
            
            break;
        case 13:
            const selectedObject = result[selectedItem];
            if (selectedObject && selectedObject.url) {
                location.href = selectedObject.url;
            } else {
                location.href = opt.searchUrl;
            }
            break;
        default:
            break;
    }
};

export const handleClickSearch = (opt, isBigSearch) => (dispatch, getState) => {
    const { result } = isBigSearch ? getState().quickBigSearch : getState().quickSearch;

    if (!result || !result.length) {
        return;
    }
    location.href = opt.searchUrl;
};

const selectItem = (selectedItem) => ({
    type: QUICK_SEARCH_SELECT_ITEM,
    payload: {
        selectedItem,
    },
});

const selectBigItem = (selectedItem) => ({
    type: QUICK_BIG_SEARCH_SELECT_ITEM,
    payload: {
        selectedItem,
    },
});